import { Box, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { displayTotalAmount } from '../../utils/currencyHelper/priceHelper';
import { useCopy } from '../../utils/useCopy';
import {
  RESERVATION_RECEIPT_PREFIX_TIP_LABEL,
  RESERVATION_RECEIPT_SERVICE_FEE_LABEL,
  RESERVATION_RECEIPT_TOTAL_LABEL,
  RESERVATION_SERVICE_CHARGE_TOOLTIP,
  TAX_LABEL,
  TOTAL_CHARGE_LABEL,
} from '../../assets/copy';
import { displayUSD } from '../../utils/currencyHelper';
import InfoIconTooltip from '../../components/core/InfoIconTooltip';
import Typography from '../../components/overrides/Typography';

const createPaymentLabel = (
  label = '',
  amount = 0,
  labelVariant = 'small2Normal',
  tooltipMessage = ''
) => ({
  label,
  amount,
  labelVariant,
  tooltipMessage,
});

const useStyles = makeStyles((theme) => ({
  blackToolTip: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
    borderRadius: '2px',
    lineHeight: '21px',
    fontSize: '14px',
    width: 'auto',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('xl')]: {
      marginLeft: theme.spacing(4),
      width: '256px',
    },
  },
  informationIcon: {
    margin: theme.spacing(0.5),
    width: '.85rem',
    height: '.85rem',
  },
  gridTotalChargeContainer: {
    justifyContent: 'space-between',
  },
  gridChargeBreakdownContainer: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.grayLight,
    justifyContent: 'space-between',
    padding: theme.spacing(1.5),
    boxSizing: 'border-box',
    borderRadius: 8,
    gap: 8,
  },
  paymentBreakDownTitleLabel: {
    color: theme.palette.digitalGray[90],
  },
  paymentBreakDownChargeLabel: {
    color: '#444649',
  },
  totalChargeTitleLabel: {
    color: theme.palette.digitalGray[120],
  },
  gridItem: {
    flexDrection: 'row',
    display: 'flex',
  },
}));

const ReservationChargesBreakdown = ({ reservation, guests }) => {
  const classes = useStyles();
  const { getCopy } = useCopy();
  const { subtotal, serviceChargeAmt, taxAmt, mandatedGratuityAmt, cost } =
    reservation;

  const displayBreakdownCharges = (args) => {
    return args
      ?.filter(({ amount }) => amount > 0)
      .map((charge, index) => (
        <>
          <Grid
            container
            style={{ justifyContent: 'space-between' }}
            size={12}
            key={`${charge.label}-${index}`}>
            <Grid size={6} className={classes.gridItem}>
              <Typography
                variant={charge.labelVariant}
                className={classes.paymentBreakDownTitleLabel}>
                {charge.label}
              </Typography>
              {charge?.tooltipMessage && (
                <InfoIconTooltip
                  title={charge.tooltipMessage}
                  tooltipStyle={classes.blackToolTip}
                  infoIconStyle={classes.informationIcon}
                />
              )}
            </Grid>
            <Grid size={6}>
              <Typography
                variant="small2Normal"
                className={classes.paymentBreakDownChargeLabel}>
                {displayUSD(charge.amount)}
              </Typography>
            </Grid>
          </Grid>
        </>
      ));
  };

  return (
    <Box>
      <Grid container size={12} className={classes.gridTotalChargeContainer}>
        <Grid size={6}>
          <Typography variant="medium1Semibold" component="h3">
            {TOTAL_CHARGE_LABEL}
          </Typography>
        </Grid>
        <Grid size={6}>
          <Typography variant="medium2Normal" component="h3">
            {displayTotalAmount(reservation)}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        size={12}
        className={classes.gridChargeBreakdownContainer}>
        {displayBreakdownCharges([
          createPaymentLabel(
            getCopy('RESERVATION_RECEIPT_RESERVATION_FEE_LABEL_WITH_GUEST', {
              guestNumber: guests,
              amount: displayUSD(cost),
            }),
            subtotal,
            'small2Normal'
          ),
          createPaymentLabel(TAX_LABEL, taxAmt, 'small2Normal'),
          createPaymentLabel(
            RESERVATION_RECEIPT_SERVICE_FEE_LABEL,
            serviceChargeAmt,
            'small2Normal',
            RESERVATION_SERVICE_CHARGE_TOOLTIP
          ),
          createPaymentLabel(
            RESERVATION_RECEIPT_PREFIX_TIP_LABEL,
            mandatedGratuityAmt,
            'small2Normal'
          ),
        ])}
        <Grid size={6} className={classes.totalChargeTitleLabel}>
          <Typography variant="small2Semibold">
            {RESERVATION_RECEIPT_TOTAL_LABEL}
          </Typography>
        </Grid>
        <Grid size={6}>
          <Typography
            variant="small2Normal"
            className={classes.paymentBreakDownChargeLabel}>
            {displayTotalAmount(reservation)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReservationChargesBreakdown;
